import React from 'react';
import './RankChart.css';

import businessData from '../assets/data/business.json';

const RankChart = () => {
  // 从业务数据中提取排名，按得分降序排列
  const rankings = [...businessData.unitPerformance]
    .sort((a, b) => b.score - a.score)
    .map((item, index) => ({
      rank: index + 1,
      unit: item.name,
      score: item.score,
      change: '+0.5%' // 模拟变化
    }));

  return (
    <div className="rank-chart">
      <div className="rank-header">
        <span className="rank-col">排名</span>
        <span className="unit-col">单位</span>
        <span className="score-col">得分</span>
        <span className="change-col">变化</span>
      </div>
      <div className="rank-list">
        {rankings.map((item, index) => (
          <div 
            key={index} 
            className={`rank-item ${item.rank <= 3 ? 'top-three' : ''}`}
          >
            <span className="rank-col">{item.rank}</span>
            <span className="unit-col">{item.unit}</span>
            <span className="score-col">{item.score}</span>
            <span className="change-col">{item.change}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RankChart;